<template>
  <div>
    <div
      class="btn-group-fab"
      role="group"
      aria-label="FAB Menu"
      :class="{ active: isActive }"
    >
      <div>
        <!-- Main Button -->
        <button
          type="button"
          class="btn btn-main btn-primary has-tooltip d-flex align-items-center justify-content-center"
          title="Menu"
          @click="toggleActive"
        >
          <img src="~@/assets/img/menu.svg" alt="Menu" />
        </button>

        <!-- All Sub-Buttons with Error States -->

        <button
          @click="smoothScroll('futuro-customer-value')"
          :class="{ 'has-error': errorStates['futuro-customer-value'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Investimento"
        >
          <img src="~@/assets/img/ic-smile.svg" alt="Investimento" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-info')"
          :class="{ 'has-error': errorStates['futuro-customer-info'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Dados pessoais"
        >
          <img src="~@/assets/img/ic-user.svg" alt="Dados pessoais" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-cash')"
          :class="{ 'has-error': errorStates['futuro-customer-cash'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Fluxo de caixa"
        >
          <img src="~@/assets/img/ic-cash-flow.svg" alt="Fluxo de caixa" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-additional')"
          :class="{ 'has-error': errorStates['futuro-customer-additional'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Informações adicionais"
        >
          <img
            src="~@/assets/img/plus-circle.svg"
            alt="Informações adicionais"
          />
        </button>

        <button
          @click="smoothScroll('futuro-customer-financial')"
          :class="{ 'has-error': errorStates['futuro-customer-financial'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Informações financeiras"
        >
          <img
            src="~@/assets/img/ic-info-money.svg"
            alt="Informações financeiras"
          />
        </button>

        <button
          @click="smoothScroll('futuro-customer-interest-in-living-abroad')"
          :class="{
            'has-error':
              errorStates['futuro-customer-interest-in-living-abroad'],
          }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Investimentos internacionais"
        >
          <img src="~@/assets/img/ic-travel.svg" alt="Aposentadoria" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-investiment')"
          :class="{ 'has-error': errorStates['futuro-customer-investiment'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Investimentos"
        >
          <img src="~@/assets/img/ic-chart.svg" alt="Investimentos" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-retirement')"
          :class="{ 'has-error': errorStates['futuro-customer-retirement'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Aposentadoria"
        >
          <img src="~@/assets/img/ic-retirement.svg" alt="Aposentadoria" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-debts')"
          :class="{ 'has-error': errorStates['futuro-customer-debts'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Dívidas"
        >
          <img src="~@/assets/img/ic-debt.svg" alt="Dívidas" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-health')"
          :class="{ 'has-error': errorStates['futuro-customer-health'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Plano de saúde"
        >
          <img src="~@/assets/img/ic-health.svg" alt="Plano de saúde" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-professional-insurance')"
          :class="{
            'has-error': errorStates['futuro-customer-professional-insurance'],
          }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Seguro profissional"
        >
          <img
            src="~@/assets/img/ic-professionao-insurance.svg"
            alt="Seguro profissional"
          />
        </button>

        <button
          @click="smoothScroll('futuro-customer-insurance')"
          :class="{ 'has-error': errorStates['futuro-customer-insurance'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Seguro de vida"
        >
          <img src="~@/assets/img/ic-globe.svg" alt="Seguro de vida" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-patrimony')"
          :class="{ 'has-error': errorStates['futuro-customer-patrimony'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Patrimônio"
        >
          <img src="~@/assets/img/ic-home.svg" alt="Patrimônio" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-acquisition')"
          :class="{ 'has-error': errorStates['futuro-customer-acquisition'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Aquisição de bens"
        >
          <img src="~@/assets/img/car.svg" alt="Aquisição de bens" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-mounthly')"
          :class="{ 'has-error': errorStates['futuro-customer-mounthly'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Investimento mensal"
        >
          <img src="~@/assets/img/calendar.svg" alt="Investimento mensal" />
        </button>

        <button
          @click="smoothScroll('futuro-customer-goals')"
          :class="{ 'has-error': errorStates['futuro-customer-goals'] }"
          class="btn btn-sub has-tooltip d-flex align-items-center justify-content-center"
          title="Quais seus principais objetivos?"
        >
          <img src="~@/assets/img/ic-goals.svg" alt="Objetivos" />
        </button>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "../store/types";

export default {
  data() {
    return {
      isActive: true,
      errorStates: {},
      // Map between Portuguese error names and section IDs
      errorMapping: {
        "Dados pessoais": "futuro-customer-info",
        Objetivos: "futuro-customer-goals",
        Proposta: "futuro-customer-value",
        "Fluxo de caixa": "futuro-customer-cash",
        "Informações adicionais": "futuro-customer-additional",
        "Informações financeiras": "futuro-customer-financial",
        "Investimentos internacionais":
          "futuro-customer-interest-in-living-abroad",
        Investimento: "futuro-customer-investiment",
        Aposentadoria: "futuro-customer-retirement",
        Dívidas: "futuro-customer-debts",
        "Plano de saúde": "futuro-customer-health",
        "Seguro profissional": "futuro-customer-professional-insurance",
        "Seguro de vida": "futuro-customer-insurance",
        Patrimônio: "futuro-customer-patrimony",
        "Aquisição de bens": "futuro-customer-acquisition",
        "Investimento mensal": "futuro-customer-mounthly",
        Patrimônio: "futuro-customer-patrimony",

        // Add other mappings as needed
      },
    };
  },
  computed: {
    ...mapGetters({
      fieldsToFillIn: types.FIELDS_TO_FILL_IN,
    }),
  },
  watch: {
    fieldsToFillIn: {
      immediate: true,
      handler(newErrors) {
        const states = {};
        // Initialize all sections to false
        Object.values(this.errorMapping).forEach((section) => {
          states[section] = false;
        });

        // Set true for sections with errors
        newErrors.forEach((error) => {
          if (this.errorMapping[error]) {
            states[this.errorMapping[error]] = true;
          }
        });

        this.errorStates = states;
      },
    },
  },
  methods: {
    hasError(sectionId) {
      return this.errorStates[sectionId] || false;
    },
    toggleActive() {
      this.isActive = !this.isActive;
    },
    initializeTooltips() {
      const tooltips = document.querySelectorAll(".has-tooltip");
      tooltips.forEach((tooltip) => {
        tooltip.addEventListener("mouseenter", () => {
          const tooltipText = tooltip.getAttribute("title");
          const tooltipElement = document.createElement("div");
          tooltipElement.classList.add("tooltip");
          tooltipElement.textContent = tooltipText;
          document.body.appendChild(tooltipElement);
        });
        tooltip.addEventListener("mouseleave", () => {
          const tooltipElement = document.querySelector(".tooltip");
          if (tooltipElement) {
            tooltipElement.remove();
          }
        });
      });
    },
    smoothScroll(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        const topOffset = section.offsetTop - 90;
        window.scrollTo({
          top: topOffset,
          behavior: "smooth",
        });
      }
    },
  },
  mounted() {
    this.initializeTooltips();
  },
};
</script>

<style lang="scss" scoped>
.has-error {
  border: 3px solid #ff0000 !important;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(255, 0, 0, 0.3) !important;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

body {
  width: 100%;
  height: 100%;
}

.btn-group-fab {
  position: fixed;
  width: 50px;
  height: auto;
  right: 20px;
  bottom: 20px;
  z-index: 3;

  div {
    position: relative;
    width: 100%;
    height: auto;
  }

  @media (max-height: 595.98px) {
    display: none;
  }

  .btn {
    position: absolute;
    bottom: 0;
    border-radius: 50%;
    display: block;
    margin-bottom: 4px;
    width: 40px;
    height: 40px;
    margin: 4px auto;
  }

  .btn-main {
    width: 50px;
    height: 50px;
    right: 50%;
    margin-right: -25px;
    z-index: 9;
    background-color: #303b52 !important;
    border-color: #303b52 !important;
    
    @media (max-height: 824px) {
      width: 40px;
      height: 40px;
      padding: 0 !important;
      right: 28px;

      img {
        height: 18px !important;
      }
    }
  }

  .btn-sub {
    bottom: 5px;
    z-index: 8;
    right: 50%;
    margin-right: -20px;
    transition: all 0.5s;

    background-color: #fff;

    img {
      width: 20px;
      height: 20px;
      filter: invert(32%) sepia(87%) saturate(3896%) hue-rotate(194deg)
        brightness(101%) contrast(99%);
    }

    @media (max-height: 824px) {
      width: 25px;
      height: 25px;
      padding: 0;
      right: 32px;

      img {
        width: 12.5px;
        height: 12.5px;
      }
    }
  }

  &.active {
    @for $i from 2 through 17 {
      .btn-sub:nth-child(#{$i}) {
        bottom: 60px + 50px * ($i - 2);
      }
    }

    @media (max-height: 824px) {
      @for $i from 2 through 17 {
        .btn-sub:nth-child(#{$i}) {
          bottom: 50px + 33px * ($i - 2);
        }
      }
    }
  }
}
</style>
